// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"225":"576a1245","354":"16b37055","594":"329ace6e","838":"35f7e8a3"}[chunkId] + ".js";
};